import { useState } from 'react'
import { useAssinaturaNotificacoes } from '@/hooks/useDocumentoAssinaturas'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { fdt } from '@/lib/helpers'
import { Bell, CheckCheck } from 'lucide-react'

export default function AssinaturaNotificacoesBadge() {
  const { notificacoes, count, marcarLida, marcarTodasLidas } = useAssinaturaNotificacoes()
  const [open, setOpen] = useState(false)

  if (count === 0) return null

  return (
    <>
      <button onClick={() => setOpen(true)} className="relative p-2 rounded-lg transition-all" style={{ background: 'hsl(var(--amber-bg))' }}>
        <Bell size={16} style={{ color: 'hsl(var(--amber))' }} />
        <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full text-[9px] font-bold flex items-center justify-center"
          style={{ background: 'hsl(var(--rose))', color: '#fff' }}>
          {count}
        </span>
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm bg-card border-border max-h-[70vh] overflow-y-auto">
          <DialogHeader>
            <div className="flex items-center justify-between">
              <DialogTitle className="text-foreground font-extrabold flex items-center gap-2">
                <Bell size={16} /> Assinaturas Pendentes
              </DialogTitle>
              {count > 1 && (
                <Button variant="ghost" size="sm" className="text-[10px] gap-1" onClick={marcarTodasLidas}>
                  <CheckCheck size={12} /> Limpar
                </Button>
              )}
            </div>
          </DialogHeader>
          <div className="space-y-2 mt-2">
            {notificacoes.map(n => (
              <div key={n.id} className="rounded-lg p-3 border cursor-pointer transition-all hover:brightness-110"
                style={{ background: 'hsl(var(--amber-bg))', borderColor: 'hsl(var(--amber) / 0.2)' }}
                onClick={() => marcarLida(n.id)}>
                <div className="text-xs font-bold text-foreground">{n.titulo}</div>
                {n.mensagem && <p className="text-[10px] text-muted-foreground mt-0.5">{n.mensagem}</p>}
                <span className="text-[9px] text-muted-foreground">{fdt(n.created_at)}</span>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
